export default __webpack_public_path__ + "static/media/ad-5.ede29a5d.jpeg";